const PortfolioSection = () => {
  const projects = [
    {
      title: 'Commercial Installation',
      subtitle: '500+ camera surveillance system',
      image: 'https://public.readdy.ai/ai/img_res/a0a2fa54e7d0426076aca5d10c18130d.jpg',
      size: 'large',
    },
    {
      title: 'Residential Security',
      status: 'COMPLETED 2024',
      subtitle: 'Complete home security system',
      image: 'https://readdy.ai/api/search-image?query=modern%20residential%20home%20with%20security%20cameras%20and%20access%20control%20system%20installed%20elegant%20house%20exterior%20simple%20background%20professional%20installation%20high%20quality%20photography&width=600&height=600&seq=residential-project&orientation=squarish',
      size: 'medium',
    },
    {
      title: 'Access Control Project',
      status: 'COMPLETED 2024',
      subtitle: 'Multi-building access system',
      image: 'https://readdy.ai/api/search-image?query=modern%20office%20building%20entrance%20with%20access%20control%20system%20keycard%20readers%20visible%20professional%20installation%20simple%20background%20high%20quality%20photography&width=600&height=600&seq=access-project&orientation=squarish',
      size: 'medium',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <div className="inline-block mb-4">
              <span className="text-sm font-medium text-dark flex items-center gap-2">
                <span className="w-2 h-2 bg-primary rounded-full"></span>
                OUR WORK
              </span>
            </div>
            <h2 className="text-5xl font-serif font-bold text-dark leading-tight">
              Proven Track Record Across the Bay Area
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-gray-600 leading-relaxed">
              With over a decade of experience, we've successfully completed hundreds of security installations for residential homes, commercial buildings, and industrial facilities throughout the Bay Area. Our expert team delivers reliable, cutting-edge security solutions tailored to each client's unique needs.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="relative rounded-2xl overflow-hidden h-[500px] group cursor-pointer">
              <img
                src={projects[0].image}
                alt={projects[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <h3 className="text-3xl font-bold text-white mb-2">{projects[0].title}</h3>
                <p className="text-gray-200">{projects[0].subtitle}</p>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            {projects.slice(1).map((project, index) => (
              <div
                key={index}
                className="relative rounded-2xl overflow-hidden h-[242px] group cursor-pointer"
              >
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute top-6 left-6">
                  <span className="inline-block bg-white/20 backdrop-blur-sm px-3 py-1 rounded-full text-white text-xs font-medium">
                    {project.status}
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-xl font-bold text-white mb-1">{project.title}</h3>
                  <p className="text-gray-200 text-sm">{project.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;